export enum Role {
    Requester = 'Requester',
    Administrator = 'Administrator',
    Support = 'Support'
}